import { render } from "./RegistrationCompensationTableAmountCellComponent.vue?vue&type=template&id=12e5d20f&scoped=true"
import script from "./RegistrationCompensationTableAmountCellComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompensationTableAmountCellComponent.vue?vue&type=script&lang=js"

import "./RegistrationCompensationTableAmountCellComponent.vue?vue&type=style&index=0&id=12e5d20f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e5d20f"]])

export default __exports__